import { AvatarClinic } from '@davincihealthcare/elty-design-system-react';
import { DistancePill } from '@/app/_components/widgets/listing/card/DistancePill';

const FakeClinicHeader = () => {
  return (
    <div className="pointer-events-none inset-0 z-0 flex select-none flex-row gap-2 px-3 py-2 blur-sm">
      <AvatarClinic src={undefined} alt="Clinic Logo" size={'small'} />

      <div className="flex min-w-0 flex-1 flex-col justify-center gap-1">
        <div className="text-base font-bold text-neutral-darker">Nome Clinica</div>
        <div className="flex min-w-0 flex-row flex-nowrap items-center justify-between gap-2 md:flex-col md:items-start md:gap-1">
          <span className="block min-w-0 max-w-full flex-1 truncate text-xs font-medium text-neutral-lighter">
            Via Tal dei Tali 21 - 20100 Milano
          </span>
          <DistancePill distance={20800} />
        </div>
      </div>

      <div className="hidden w-full max-w-sm grid-cols-2 gap-4 md:grid">
        <div className="flex flex-col items-center gap-1 text-nowrap rounded-lg bg-[#F1F7FE] p-2">
          <p className="text-sm font-medium text-neutral-lighter">Prima disponibilità</p>
          <p className="text-2xl font-bold leading-9 text-neutral-darker">Domani</p>
        </div>

        <div className="flex flex-col items-center gap-1 text-nowrap rounded-lg bg-[#F1F7FE] p-2">
          <p className="text-sm font-medium text-neutral-lighter">A partire da</p>
          <p className="text-2xl font-bold leading-9 text-neutral-darker">75€</p>
        </div>
      </div>
    </div>
  );
};

export default FakeClinicHeader;
